export const CONFIGURATION_KEY = {
  CURRENT_RECRUITING_YEAR: 'RecruitingClassYear',
  NFL_DRAFT_YEAR: 'NFLDraftYear',
  NEW_HS_PLAYERS_DAYS: 'NewHSPlayersDays',
  NEW_COLLEGE_PLAYERS_DAYS: 'NewCollegePlayersDays',
  DASHBOARD_ROLLOVER_DAY: 'DashboardRolloverDate',
  DASHBOARD_ROLLOVER_MONTH: 'DashboardRolloverMonth',
  ROLLOVER_DAY: 'RolloverDate',
  ROLLOVER_MONTH: 'RolloverMonth',
  ROLLOVER_DAY_NFL: 'RolloverDateNFL',
  ROLLOVER_MONTH_NFL: 'RolloverMonthNFL',
  TRACK_DATE_PAST_YEAR_LIMIT: 'TrackDatePastYearLimit',
  ROLLOVER_DATE_TRANSFER_PORTAL: 'RolloverDateTransferPortal',
  ROLLOVER_MONTH_TRANSFER_PORTAL: 'RolloverMonthTransferPortal',
  FBS_PROFILER_MIN_YEAR: 'FBSProfilerMinYear',
  FCS_PROFILER_MIN_YEAR: 'FCSProfilerMinYear',
  QB_PROFILER_MIN_PASSING_ATTEMPT: 'QBProfilerMinPassingAttempt',
  RUSHER_PROFILER_MIN_RUSHING_ATTEMPT: 'RusherProfilerMinRushingAttempt',
  RECEIVER_PROFILER_MIN_RECEPTIONS: 'ReceiverProfilerMinReceptions',
  DEFENDER_PROFILER_MIN_DEFENSIVE_SNAPS: 'DefenderProfilerMinDefensiveSnaps',
};

export default interface Configuration {
  key: string;
  value: string;
}
